import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api } from "../lib/api";

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState({ action: "", entity_type: "" });

  const load = async () => {
    const params = {};
    if (filter.action) params.action = filter.action;
    if (filter.entity_type) params.entity_type = filter.entity_type;
    const { data } = await api.get("/audit-logs", { params });
    setLogs(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  return (
    <AppShell title="Audit Logs">
      <div className="ds-card p-3 mb-4 flex flex-wrap gap-3" data-testid="audit-filter">
        <input className="ds-input w-56" placeholder="action (e.g. login)" value={filter.action} onChange={(e) => setFilter({ ...filter, action: e.target.value })} data-testid="filter-action" />
        <input className="ds-input w-56" placeholder="entity type (e.g. document)" value={filter.entity_type} onChange={(e) => setFilter({ ...filter, entity_type: e.target.value })} data-testid="filter-entity" />
      </div>
      <div className="ds-card overflow-x-auto">
        <table className="ds-table" data-testid="audit-table">
          <thead>
            <tr>
              <th>Time</th><th>Actor</th><th>Role</th><th>Action</th><th>Entity</th><th>ID</th><th>Meta</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id}>
                <td className="font-mono text-[11px]">{new Date(l.created_at).toLocaleString()}</td>
                <td>{l.actor_name}</td>
                <td>{l.actor_role}</td>
                <td className="font-mono text-[12px]">{l.action}</td>
                <td>{l.entity_type}</td>
                <td className="font-mono text-[11px]">{(l.entity_id || "").slice(0, 8)}</td>
                <td className="font-mono text-[11px] text-[#4A4A52] truncate max-w-[260px]">{JSON.stringify(l.metadata || {})}</td>
              </tr>
            ))}
            {logs.length === 0 && (
              <tr><td colSpan={7} className="text-center text-[#8A8A93] py-8">No audit logs.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
